import styled, { CSSObject } from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import type { BadgeType } from './Badge'

const variantToStylesMap: Record<BadgeType, CSSObject> = {
  red: {
    borderColor: tokens.color.airPresto.p,
    color: tokens.color.airPresto[700]
  },
  orange: {
    borderColor: tokens.color.roshe[400],
    color: tokens.color.roshe[800]
  },
  green: {
    borderColor: tokens.color.airForce.p,
    color: tokens.color.airForce[700]
  },
  blue: {
    borderColor: tokens.color.foamRunner.p,
    color: tokens.color.foamRunner[700]
  },
  default: {}
}

const variantToHoverStylesMap: Record<BadgeType, CSSObject> = {
  red: { backgroundColor: tokens.color.airJordan[50] },
  orange: { backgroundColor: tokens.color.roshe[50] },
  green: { backgroundColor: tokens.color.airForce[50] },
  blue: { backgroundColor: tokens.color.foamRunner[50] },
  default: { backgroundColor: 'transparent' }
}

export const Badge = styled.span<{ variant: BadgeType; hover: boolean }>(
  {
    background: 'transparent',
    borderRadius: '999px',
    border: `${tokens.borderWidth.xs} solid`,
    display: 'inline-block',
    fontSize: tokens.fontSize[1],
    lineHeight: '32px',
    padding: `0 ${tokens.spacing[5]}`,
    whiteSpace: 'nowrap',
    color: tokens.color.airJordan[600],
    borderColor: tokens.color.airJordan[400],
    height: '32px'
  },
  ({ variant }) => variantToStylesMap[variant],
  ({ hover, variant }) => ({
    ':hover': hover
      ? variantToHoverStylesMap[variant]
      : { backgroundColor: 'transparent' }
  })
)
